/**
 * Legacy CustomerServiceApiService module — preserved as an empty AngularJS
 * module so existing dependencies (`acme.common.service.customerServiceApi`)
 * keep resolving.
 *
 * The actual CustomerServiceApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/customer-service/customer-service-api.service.ts
 */
angular.module("acme.common.service.customerServiceApi", [
  "acme.common.factory.QueryStringBuilder",
]);
